'use client';

/**
 * HandoffTimeoutSubmitted — terminal "we got it" view of the timeout
 * recovery flow (see handoff-timeout-panel.tsx). No further actions from
 * here: the flow is done, and the composer below returns to plain "Ask
 * anything" copy once the handoff formally ends (see
 * lib/composer-placeholder.ts) — this card is the only confirmation the
 * user needs.
 */
import { Check } from 'lucide-react';
import { StandardCard } from './primitives/standard-card';
import { SupportRequestType } from '@/lib/api/support-requests';

interface HandoffTimeoutSubmittedProps {
  type: SupportRequestType;
}

const COPY: Record<
  SupportRequestType,
  { eyebrow: string; title: string; body: string }
> = {
  [SupportRequestType.MESSAGE]: {
    eyebrow: 'MESSAGE SENT',
    title: 'Your message is on its way',
    body: 'Thanks for reaching out — a guide will read your message and reply by email, usually within a few hours.',
  },
  [SupportRequestType.CALLBACK]: {
    eyebrow: 'CALL-BACK REQUESTED',
    title: "We'll call you back",
    body: 'Thanks — a guide will call you back during your selected time. No further action needed on your end.',
  },
};

export function HandoffTimeoutSubmitted({
  type,
}: HandoffTimeoutSubmittedProps) {
  const copy = COPY[type];
  return (
    <StandardCard
      tone="success"
      icon={
        <Check aria-hidden="true" className="size-[15px]" strokeWidth={2.5} />
      }
      eyebrow={copy.eyebrow}
      title={copy.title}
    >
      {copy.body}
    </StandardCard>
  );
}
